export const PASSWORD_MINIMUM_LENGTH = 12;
